import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { store } from './store.js';
import { Provider } from 'react-redux';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
